import { GetCustomers200 } from "api/generated/schemas";

export const getCompanyName = (
  data: GetCustomers200 | undefined,
  ban: string
) => (data ? data._data?.find((d) => d.ban === ban)?.accountName : "");
